import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import { UNAUTHORIZED_EVENT } from '@/core/api/auth-token'
import { router } from '@/app/router'
import { createQueryClient } from '@/core/api/query-client'
import { setupECharts } from '@/core/charts/echarts'
import { useAuthStore } from '@/stores/auth.store'
import './assets/index.css'
// Wajib: style dasar toaster (positioning + z-index). Tanpa ini toast tak terlihat.
import 'vue-sonner/style.css'

setupECharts()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, { queryClient: createQueryClient() })

// Token sesi ditolak server (401) → bersihkan sesi & arahkan ke login.
window.addEventListener(UNAUTHORIZED_EVENT, () => {
  const auth = useAuthStore()
  auth.clearSession()
  if (router.currentRoute.value.name !== 'login') {
    void router.replace({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  }
})

app.mount('#app')
